import { useEnvMapLoader, useModelExporter } from '#imports';
import { ref, watchEffect } from 'vue';

import { usePane } from '@resn/gozer-vue';

import { getAllMeshes } from '../../utils';

export const useBaseObject = ({ object, name = 'BaseObject' }) => {
    const meshes = getAllMeshes(object);

    const { envMap } = useEnvMapLoader();

    const fresnel = ref(0);
    // const fresnelPower = ref(1.2);
    // const fresnelColor = ref('#4715ac'); // 4715ac || b42ddf || 48cfff

    const fresnelPower = ref(6);
    const fresnelColor = ref('#fff');
    const fresnelStr = ref(0.5);

    const uOverlayColor = ref('#000');
    const uOverlayStr = ref(0);

    watchEffect(() => {
        meshes.forEach((mesh) => {
            mesh.material.envMap = envMap.value;
        });
    });

    watchEffect(() => {
        meshes.forEach((mesh) => {
            if (!mesh.material.uniforms) return;

            mesh.material.uFresnel = fresnel.value;
            mesh.material.uFresnelPower = fresnelPower.value;
            mesh.material.uFresnelColor.set(fresnelColor.value);
            mesh.material.uFresnelStr = fresnelStr.value;

            mesh.material.uOverlayColor.set(uOverlayColor.value);
            mesh.material.uOverlayStr = uOverlayStr.value;
        });
    });

    const modelExport = useModelExporter();

    // if (!modelExport) {
    //     usePane(
    //         [
    //             { name: 'fresnel', value: fresnel, options: { min: 0, max: 1, step: 0.01 } },
    //             {
    //                 name: 'fresnelPower',
    //                 value: fresnelPower,
    //                 options: { min: 0, max: 10, step: 0.1 },
    //             },
    //             { name: 'fresnelColor', value: fresnelColor },
    //             { name: 'fresnelStr', value: fresnelStr, options: { min: 0, max: 1, step: 0.01 } },
    //             { name: 'fresnelStr', value: fresnelStr, options: { min: 0, max: 1, step: 0.01 } },

    //             { name: 'uOverlayColor', value: uOverlayColor },
    //             {
    //                 name: 'uOverlayStr',
    //                 value: uOverlayStr,
    //                 options: { min: 0, max: 1, step: 0.01 },
    //             },
    //         ],
    //         {
    //             title: `${name} Scene Object`,
    //         }
    //     );
    // }
};
